export class CustomFieldAnswer {
    custom_field: number;
    value = '';
    choices: number[] = [];
}
